<template>
  <b-card class="shadow-sm">
    <b-card-title class="mb-4 pt-6 px-6 d-flex justify-content-between">
      <div>
        <b-icon icon="cart-fill" variant="primary" class="mr-2" />
        <span>Relação de Vendas</span>
      </div>

      <!-- Filtro comparativo (ex.: ano x ano, mês x mês, etc.) -->
      <FiltroComparativo
        class="mt-1"
        :auto-apply-on-mount="!ignoreInitialApply"
        @change-comparacao="onChangeComparacao"
      />
    </b-card-title>

    <b-card-body class="px-6 pb-6 pt-2">
      <!-- LOADING (mesmo padrão da lista de produtos mais vendidos) -->
      <template v-if="loading">
        <ul class="list-unstyled m-0 p-0">
          <li v-for="i in 5" :key="i" class="d-flex align-items-center mb-6">
            <div
              class="d-flex justify-content-center align-items-center rounded-circle mr-4"
              style="width: 36px; height: 36px; background-color: #f3f6f9"
            >
              <b-skeleton width="18px" height="18px" />
            </div>
            <div class="flex-grow-1" style="width: 100%">
              <div class="d-flex justify-content-between">
                <b-skeleton width="40%" height="16px" />
                <b-skeleton width="20%" height="14px" />
              </div>
              <b-skeleton height="8px" class="mt-2" />
            </div>
          </li>
        </ul>
      </template>

      <!-- CHART -->
      <template v-else>
        <apexchart
          :key="chartKey"
          height="280"
          :options="chartOptions"
          :series="chartSeries"
        />
        <div v-if="!chartSeries.length" class="text-center py-3">
          <small class="text-muted">Sem dados para o período selecionado</small>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import FiltroComparativo from "./FiltroComparativo.vue";

export default {
  name: "VendasComparativo",
  components: { FiltroComparativo },

  props: {
    /**
     * Aceita:
     *  - { data: { series: [{name, data}], categories: [] } }
     *  - ou flat: { series: [...], categories: [...] }
     */
    dados: {
      type: Object,
      default: () => ({ data: { series: [], categories: [] } }),
    },
    loading: { type: Boolean, default: false },
    ignoreInitialApply: { type: Boolean, default: true },
  },

  data() {
    return {
      chartKey: 0, // força redesenho do apex quando dados mudam
    };
  },

  computed: {
    categories() {
      return this.dados?.categories ?? this.dados?.data?.categories ?? [];
    },
    chartSeries() {
      const s = this.dados?.series ?? this.dados?.data?.series;
      return Array.isArray(s)
        ? s.map((it) => ({
            name: it?.name ?? "",
            data: Array.isArray(it?.data) ? it.data : [],
          }))
        : [];
    },
    chartOptions() {
      return {
        chart: { type: "line", toolbar: { show: false } },
        stroke: { curve: "smooth", width: 3 },
        markers: { size: 4 },
        colors: ["#1E90FF", "#A9A9A9", "#2ECC71", "#E67E22"],
        xaxis: { categories: this.categories, tickPlacement: "on" },
        yaxis: {
          labels: {
            formatter: (val) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 0,
              }).format(val || 0),
          },
        },
        tooltip: {
          y: {
            formatter: (val) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(val || 0),
          },
        },
        legend: { show: true },
      };
    },
  },

  watch: {
    // quando os dados mudarem (ex.: novo filtro), força redesenho
    dados: {
      deep: true,
      handler() {
        this.chartKey++;
      },
    },
  },

  methods: {
    // reemite SEMPRE pro pai buscar no back
    onChangeComparacao(payload) {
      // payload: { modeId, label, a:{inicio,fim}, b:{inicio,fim} }
      this.$emit("change-comparacao", payload);
    },
  },
};
</script>
